import { isEmpty } from "lodash-es";

/**
 * Helper function to check if a key is a valid variant key.
 * @param key - The key to check.
 * @param variantObject - The variant object to check.
 * @returns True if the key is a valid variant key, false otherwise.
 */
const isVariantKey = <T extends string>(
  key: string,
  variantObject: VariantObject<T>
): key is T => key in variantObject;

/**
 * Helper function to get a variant object.
 * @param key - The key to get.
 * @param variantObject - The variant object to get.
 * @returns The variant object.
 */
export const getVariantObject = <T extends string>({
  key,
  variantObject,
}: GetVariantObjectProps<T>): VariantConfig<T> | null => {
  if (isEmpty(key) || isEmpty(variantObject)) return null;
  if (!isVariantKey(key, variantObject)) return null;

  return variantObject[key];
};
